import { useEffect } from "react";
import L from "leaflet";

export default function Legend(props) {
  const map = props.map;
  const countBorders = props.countBorders;

  const colourArray = ["#F1EEF6", "#BDC9E1", "#74A9CF", "#2B8CBE", "#045A8D"];

  useEffect(() => {
    if (map && countBorders) {
      const legend = L.control({ position: "topright" });

      legend.onAdd = () => {
        const div = L.DomUtil.create("div", "info legend");
        for (let i = 0; i < countBorders.length; i++) {
          div.innerHTML +=
            '<i style="background:' +
            colourArray[i] +
            '"></i> ' +
            (i !== 0 ? countBorders[i - 1] + 1 : 0) +
            (i + 1 ? "&ndash;" + countBorders[i] + " measures<br>" : "+");
        }
        return div;
      };

      legend.addTo(map);
    }
  }, [map]); //here add map
  return null;
}
